<template>
  <div class="card-plan mb-4">
    <md-card class="m-0 md-elevation-6" md-theme="black">
      <md-card-content class="p-3 flex-column d-flex align-items-stretch">
        <div
          class="quadro-superior w-100 pt-3 pb-3 justify-content-center align-items-center d-flex"
        >
          <h1 class="md-display-0 text-white m-0 font-weight-bold">
            {{ titulo }}
          </h1>
        </div>
        <div class="d-flex flex-column mt-3">
          <h6 class="md-body-2 text-white mt-0 mb-0 align-self-center">
            Velocidade
          </h6>
          <h6
            class="mt-0 md-title font-weight-bolder align-self-center text-primary"
          >
            {{ velocidade + "Mbps" }}
          </h6>
        </div>
        <div class="d-flex flex-column mt-1">
          <md-divider class="ml-2 mt-1 mb-1 mr-2"></md-divider>
          <h6 class="md-body-2 text-white mt-0 mb-0 align-self-center">
            Franquia
          </h6>
          <h6 class="mt-0 md-title align-self-center text-primary">
            {{ franquia === -1 ? "ILIMITADA" : franquia }}
          </h6>
        </div>
        <div class="d-flex flex-column mt-1">
          <md-divider class="ml-2 mt-1 mb-1 mr-2"></md-divider>
          <h6 class="md-body-2 text-white mt-0 mb-0 align-self-center">
            Preço
          </h6>
          <h6
            v-if="valor === -1"
            class="mt-0 md-subheading align-self-center text-primary"
          >
            Indisponível
          </h6>
          <h6
            v-else
            class="mt-0 md-subheading font-weight-bold align-self-center text-primary"
          >
            R$ {{ valor.toLocaleString("pt-BR") }}<small>/mês</small>
          </h6>
        </div>
        <md-divider class="ml-2 mt-1 mb-1 mr-2"></md-divider>
        <md-button
          @click="$emit('handleButton')"
          class="md-primary md-raised"
          md-elevation="0"
          >{{ valor === -1 ? "Consultar" : "Contratar" }}</md-button
        >
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  name: "CardPlan",
  props: {
    titulo: { default: "Plano de 0MB" },
    valor: { default: -1 },
    franquia: { default: -1 },
    velocidade: { default: 0 },
  },
};
</script>

<style lang="scss">
.quadro-superior {
  background: linear-gradient(
    to right,
    rgba(229, 45, 39, 0.8),
    rgba(179, 18, 23, 0.8)
  );
  border-radius: 3px 3px 0 0;
}
</style>
